var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import HeaderItem from "../../../components/HeaderItem";
import { Prop, Watch } from 'vue-property-decorator';
import CommonService from "../../../api/CommonService";
import EHanldeStatus from '../../../enum/EHandleStatus';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.EHanldeStatus = EHanldeStatus;
        _this.orderStatusList = [];
        _this.accountOptions = [];
        _this.organBusiness = [];
        _this.receiveDepotList = [];
        _this.outOrganList = [];
        _this.orderStatus_retailSales = 2;
        _this.pickerOptions = {};
        _this.deliveryPickerOptions = {};
        return _this;
    }
    default_1.prototype.watchOrderType = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        if (newValue == this.orderStatus_retailSales) {
            this.getShop({ type: 2, freeze: 0 });
            this.formData.business_id = 0;
            this.formData.shop_id = null;
        }
        else {
            this.getShop({ type: 1, freeze: 0 });
            this.formData.business_id = '';
            this.formData.shop_id = null;
        }
    };
    default_1.prototype.watchOrganBusiness = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        if (newValue) {
            if (!this.organBusiness || !this.organBusiness.length) {
                this.receiveDepotList = [];
                this.outOrganList = [];
                this.formData.organ_id = '';
                return;
            }
            for (var i = 0; i < this.organBusiness.length; i++) {
                var data = this.organBusiness[i];
                for (var j = 0; j < data.children.length; j++) {
                    if (data.children[j].id == newValue) {
                        this.formData.business_id = data.id;
                        this.getReceiveDepotList({
                            business_id: data.id,
                            shop_id: newValue,
                        });
                        this.getOrganList({
                            business_id: data.id
                        });
                        return;
                    }
                }
            }
        }
        else {
            this.receiveDepotList = [];
            this.outOrganList = [];
            this.formData.organ_id = '';
            return;
        }
    };
    default_1.prototype.watchorgan_id = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        if (newValue) {
            this.getOrganDepot({
                organ_id: newValue
            });
        }
        else {
            this.otherData.outStoreList = [];
            this.formData.out_depot_id = '';
            return;
        }
    };
    default_1.prototype.watchdepot_id = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        var depotItem = this.receiveDepotList.filter(function (item) {
            return item.depot_id == newValue;
        });
        this.formData.depot_name = depotItem.depot_name;
    };
    default_1.prototype.watchPooLastTime = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Add)
            return;
        if (newValue) {
            this.deliveryPickerOptions = {
                disabledDate: function (time) {
                    return time.getTime() < new Date(newValue).getTime();
                }
            };
        }
    };
    default_1.prototype.watchLogistic = function (newValue, oldValue) {
        this.formData.logistics_number = newValue.replace(/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5、]/g, "");
    };
    default_1.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.getOrderStatusList();
        this.getAccountOptions();
        var myDate = new Date();
        this.formData.delivery_time = myDate;
        console.log(this.formData, 555);
        if (this.handleStatus === EHanldeStatus.Add) {
            this.getShop({ type: 1, freeze: 0 });
            if (myDate.getHours() < 13) {
                this.formData.expect_arrivedate = myDate;
            }
            else {
                this.formData.expect_arrivedate = new Date(myDate.getTime() + 3600 * 1000 * 24);
            }
        }
        else {
            this.getOrganList(this.formData.business_id);
        }
    };
    default_1.prototype.mounted = function () {
    };
    default_1.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    default_1.prototype.getOrganDepot = function (data) {
        var _this = this;
        this.commonService.getDepotList({
            is_init: 1,
            organ_id: data.organ_id
        }).then(function (res) {
            _this.otherData.outStoreList = res.data.data || [];
            _this.formData.out_depot_id = '';
            if (_this.otherData.outStoreList.length) {
                _this.formData.out_depot_id = _this.otherData.outStoreList[0].depot_id;
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getOrderStatusList = function () {
        this.orderStatusList = [{
                value: 1,
                name: '无单送货'
            }, {
                value: 2,
                name: '散客销售'
            }];
    };
    default_1.prototype.getOrganList = function (data) {
        var _this = this;
        var params = {
            business_id: data.business_id
        };
        return this.commonService.getOrganList(params).then(function (res) {
            var data = res.data.data;
            _this.outOrganList = data || [];
            _this.formData.organ_id = '';
            if (_this.outOrganList.length) {
                _this.formData.organ_id = _this.outOrganList[0].organ_id;
            }
            else {
                _this.$message.warning('请先将客户与分支机构绑定后再新增委托送货单');
            }
        });
    };
    default_1.prototype.getShop = function (params) {
        var _this = this;
        params = params ? params : {
            type: 1
        };
        this.commonService.getShopFilter(params).then(function (res) {
            if (res.data.success) {
                var depot = res.data.data;
                if (params.type == 2) {
                    _this.formData.business_id = depot[0].id;
                    _this.formData.shop_id = depot[0].children[0].id;
                }
                _this.organBusiness = depot;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getReceiveDepotList = function (data) {
        var _this = this;
        var params = {
            business_id: data.business_id,
            shop_id: data.shop_id,
        };
        this.commonService.getReceiveDepotList(params).then(function (res) {
            _this.receiveDepotList = res.data.data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getAccountOptions = function () {
        var _this = this;
        this.commonService.getAccountOptions().then(function (res) {
            if (res.data.success) {
                _this.accountOptions = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.onDelivererChange = function (delivererId) {
        if (delivererId) {
            var selectedDeliverer = this.accountOptions.find(function (item) { return item.account_id === delivererId; });
            if (selectedDeliverer && selectedDeliverer.mobile) {
                this.formData.deliverer_phone = selectedDeliverer.mobile;
            }
        }
        else {
            this.formData.deliverer_phone = '';
        }
    };
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "otherData", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Watch("formData.order_type")
    ], default_1.prototype, "watchOrderType", null);
    __decorate([
        Watch("formData.shop_id")
    ], default_1.prototype, "watchOrganBusiness", null);
    __decorate([
        Watch("formData.organ_id")
    ], default_1.prototype, "watchorgan_id", null);
    __decorate([
        Watch("formData.depot_id")
    ], default_1.prototype, "watchdepot_id", null);
    __decorate([
        Watch("formData.poo_last_ctime")
    ], default_1.prototype, "watchPooLastTime", null);
    __decorate([
        Watch('formData.logistics_number')
    ], default_1.prototype, "watchLogistic", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
